// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__ehrConnectBtn--csFWN {\n  align-self: flex-start;\n  font-weight: 600;\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InsuranceBillingOnboarding/steps/StepEhrScope/s.module.less"],"names":[],"mappings":"AAGA;EACI,sBAAA;EACA,gBAAA;EACA,WAAA;AAFJ","sourcesContent":["// Step 6 — EHR & billing scope 私有样式（原型 .ibbw-ehr-*）\n// 已连接 EHR 行样式移至共用组件 EhrBillingCheckList\n\n.ehrConnectBtn {\n    align-self: flex-start;\n    font-weight: 600;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ehrConnectBtn": "s-module__ehrConnectBtn--csFWN"
};
export default ___CSS_LOADER_EXPORT___;
